import { Routes } from '@angular/router';
import { NoContentComponent } from './no-content';

import { InvoiceComponent } from './invoice/invoice.component';
import { ReservationComponent } from './admin/reservation/reservation.component';
import { FrontpageComponent } from './frontpage/frontpage.component';
import { FinanceComponent } from './admin/finance/finance.component';

export const ROUTES: Routes = [
  { path: '', component: FrontpageComponent},
  { path: 'bigbools', component: FrontpageComponent},
  { path: 'yhteys', component: FrontpageComponent},
  { path: 'hinnasto-tilaa', component: FrontpageComponent},
  { path: 'reservation', component: ReservationComponent},
  { path: 'finance', component: FinanceComponent},
  { path: 'invoice/:id/:hash', component: InvoiceComponent},
  { path: '**',    component: NoContentComponent },
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/app.routes.ts